import React from 'react';
import { Navigate } from 'react-router';
import { NavLink } from 'react-router-dom';
import Base from './Base';
import { Header } from './Header';
import { Footer } from './Footer';
import DataTable from 'react-data-table-component';



export default class Documents extends Base {
    constructor(props) {
        super(props);
        this.state = {
            controllerName: 'document',
            data: null,
            loading: true,
            id_to_remove: null,
            page: 1,
            per_page: 1000,
            phrase: '',
            ids: [],
            filters: {
                type: 0,
                status: 0,
            }
        };
        this.CreateDocuments = this.CreateDocuments.bind(this);
    }
    componentDidMount() {
        this.refreshData();
    }
    setChecked(e, id) {
        var t = [];
        this.state.Ids.forEach(i => {
            if (i != id) t.push(i);
        });
        if (e.target.checked) t.push(id);
        this.state.Ids = t;
    }

    CreateDocuments() {
        this.httpPost("api/v1/document/createDocuments", {
            companyId: (this.isNull(this.state.data.global.company) ? null : this.state.data.global.company.id),
        })
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                if (data.status === 1) {
                    this.showSuccessMessage("اطلاعات با موفقیت ثبت شد");

                    this.state.data.document = data.document;

                    this.setState({ data: this.state.data });
                }
                else
                    this.showErorrMessage(data.message);
            })
            .catch(err => {
                this.showErorrMessage("پاسخی دریافت نشد.لطفا مجدد تلاش نمایید.");
            });
    }




    renderForm() {


        return <div>
            <div className="nk-content-body">
                <div className="nk-block-head nk-block-head-sm">
                    <div className="nk-block-between">
                        <div className="nk-block-head-content">
                            <h3 className="nk-block-title page-title">فهرست اسناد</h3>
                            <div className="nk-block-des text-soft">
                                <p>شما {this.money(this.state.data.recordsCount)} سند ثبت شده دارید</p>
                            </div>
                        </div>
                        <div className="nk-block-head-content">
                            <div className="toggle-wrap nk-block-tools-toggle">
                                <a href="#" className="btn btn-icon btn-trigger toggle-expand me-n1" data-target="pageMenu"><em className="icon ni ni-menu-alt-r"></em></a>
                                <div className="toggle-expand-content" data-content="pageMenu">
                                    <ul className="nk-block-tools g-3">
                                        <li>
                                            <a onClick={e => this.getPdfs(e)} className="btn btn-white btn-outline-light"><em className="icon ni ni-file-pdf"></em><span>خروجی PDF</span></a>
                                        </li>
                                        <li>
                                            <a onClick={e => this.getExcels(e)} className="btn btn-white btn-outline-light"><em className="icon ni ni-file-xls"></em><span>خروجی Excel</span></a>
                                        </li>
                                        <li>
                                            <NavLink to="/document/new/" className="btn btn-primary"><em className="icon ni ni-download-cloud"></em><span>افزودن سند جدید</span></NavLink>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="nk-block">
                    <div className="card card-bordered card-stretch">
                        {this.state.data.recordsCount <= 0 ?
                            <div className="card-inner-group">
                                <div className="example-alert">
                                    <div className="alert alert-pro alert-warning">
                                        <div className="alert-text">
                                            <h6>توجه</h6>
                                            <p>در حال حاضر هیچ سندی برای شرکت شما ثبت نشده است</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            :
                            <div className="card-inner-group">

                                    <div className ="data-table-container-wrapper custom-scroll" >

                                <DataTable
                                    columns={[
                                        {
                                            name: 'شماره سند',
                                            selector: row => row.number,
                                            sortable: true,
                                            center: true,
                                        
                                        },
                                        {
                                            name: 'شماره عطف',
                                            selector: row => row.refNumber,                                          
                                            sortable: true,
                                            center: true,
                                      
                                        },
                                        {
                                            name: 'تاریخ',
                                            selector: row => row.date,
                                            sortable: true,
                                            center: true,
                                   
                                        },
                                        {
                                            name: 'سیستم صادر کننده',
                                            selector: row => row.source,
                                            sortable: true,
                                            center: true,
                                            width: "160px",
                                            cell: row => (
                                                <>
                                                    {row.source === 1 && <span className="tb-status text-info">حسابداری</span>}
                                                    {row.source === 2 && <span className="tb-status text-info">مشتریان-فروش</span>}
                                                    {row.source === 3 && <span className="tb-status text-info">مشتریان - خرید</span>}
                                                    {row.source === 4 && <span className="tb-status text-info">انبار-حواله</span>}
                                                    {row.source === 5 && <span className="tb-status text-info">انبار-رسید</span>}
                                                </>
                                            )
                                        },
                                        {
                                            name: 'نوع',
                                            selector: row => row.type,
                                            sortable: true,
                                            center: true,
                                            
                                            cell: row => (
                                                <>    
                                                    { row.type === 1 && <span className="tb-status text-info">عادی</span> }
                                                    { row.type === 2 && <span className="tb-status text-warning">افتتاحیه</span> }
                                                    { row.type === 3 && <span className="tb-status text-danger">اختتامیه</span> }
                                                    { row.type === 4 && <span className="tb-status text-success">بستن حساب موقت</span> }
                                                </>
                                            )


                                        },
                                        {
                                            name: 'وضعیت',
                                            selector: row => row.status,
                                            sortable: true,
                                            center: true,
                                          
                                            cell: row => (
                                                <>
                                                    {row.status === 1 && <span className="tb-status text-info">یادداشت</span>}
                                                    {row.status === 2 && <span className="tb-status text-warning">موقت</span>}
                                                    {row.status === 3 && <span className="tb-status text-danger">قطعی</span>}
                                                    {row.status === 4 && <span className="tb-status text-success">نهایی</span>}
                                                </>
                                            )
                                        },
                                        {
                                            name: 'جمع سند',
                                            selector: row => row.sumBed,
                                            sortable: true,
                                            center: true,
                                           
                                            format: row => row.sumBed == null ? "" : row.sumBed.toString().replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + ","),
                                        },
                                        {
                                            name: 'عملیات',
                                            selector: row => row.source,
                                            sortable: true,
                                            center: true,
                                       
                                            cell: row => (
                                            <>
                                                    <li>
                                                        <div className="drodown">
                                                            <a href="#" className="dropdown-toggle btn btn-icon btn-trigger" data-bs-toggle="dropdown"><em className="icon ni ni-more-h"></em></a>
                                                            <div className="dropdown-menu dropdown-menu-end">
                                                                <ul className="link-list-opt no-bdr">
                                                                    <li><NavLink to={"/document/edit/" + row.id} title="ویرایش"><em className="icon ni ni-pen"></em> <span>ویرایش</span></NavLink></li>
                                                                    <li><a className="hand" onClick={e => this.confirmRemove(row.id)} data-bs-toggle="modal" data-bs-target="#modalConfirmRemove" title="حذف سند"><em className="icon ni ni-na"></em> <span>حذف سند</span></a></li>
                                                                </ul>
                                                            </div>
                                                        </div>
                                                    </li>
                                            </>

                                            )
                                        }

                                    ]}
                                    data={this.state.data.records}            
                                    className={ this.state.data.recordsCount < 6 ? 'custom-scroll data-table-container-wrapper' : 'custom-scroll' }
                                    noDataComponent="رکوردی برای نمایش وجودی ندارد"                         
                                    direction="rtl"
                                    onSelectedRowsChange={e => this.setFilterItem(e.selectedRows, 1)}
                                    persistTableHead
                                        />
                                    </div>
                                </div>

                        }
                    </div>
                </div>
            </div>
        </div>
    }
    render() {
        console.log(this.state)

        if (!this.isBlank(this.state.redirect)) return <Navigate to={this.state.redirect} />

        let contents = this.state.loading ? this.renderLoading() :
            [
                this.state.lockScreen === 1 && this.lockScreen(),
                this.getGlobalContainer(),
                <Header data={this.state.data} />,
                <div className="nk-content ">
                    <div className="container-fluid">
                        <div className="nk-content-inner">
                            {this.isEmptyAnnualsOrCompanies(this.state.data.global) ? this.renderNoCompanyOrAnnualRegister() : this.renderForm()}

                        </div>
                    </div>
                </div>,
                <Footer />
            ];

        return contents;
    }
}